<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-btn color="indigo" @click="addGoogleProductModal = true">
        <mdb-icon icon="plus" class="mr-1" />
        {{ $t("add_google_purchase_product") }}
      </mdb-btn>
    </mdb-row>
    <mdb-row>
      <DataTableAG
        :columns="columns"
        width="1860px"
        height="750px"
        :getcontentpath="getcontentpath"
        :buttonList="['Muokkaa']"
        jsonobject="purchaseproductdata"
        v-on:pressed-button1="editPurchaseProductName"
        :rowHeight="120"
        :dataUpdate="dataUpdate"
      />
    </mdb-row>
    <mdb-row>
      <ChangePurchaseProductName 
      :modalShow="editPurchaseProductNameModal"
      :id="id"
      :title="title"
      v-on:modal-cancelled="editGameleoKeywordCancelled"
      v-on:modal-ok="editGameleoKeywordOk"
      />
      <AddGooglePurchaseProduct
        :modalShow="addGoogleProductModal"
        v-on:cancelled="addGoogleProductModal = false"
        v-on:saved="googleProductSaved"
      />
    </mdb-row>
  </mdb-container>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
import ChangePurchaseProductName from "@/components/ChangePurchaseProductName.vue";
import AddGooglePurchaseProduct from "@/components/AddGooglePurchaseProduct.vue";
import { mdbBtn, mdbContainer, mdbIcon, mdbRow } from "mdbvue";

const periodUnitLabels = {
  day: "pv",
  week: "vk",
  month: "kk",
  year: "v",
};

export default {
  name: "Advertisements",
  components: {
    DataTableAG,
    AddGooglePurchaseProduct,
    mdbContainer,
    mdbBtn,
    mdbIcon,
    mdbRow,
    ChangePurchaseProductName,
  },
  data: () => ({
    getcontentpath: "/1.0/front/purchaseproductnames",
    addGoogleProductModal: false,
    editPurchaseProductNameModal: false,
    dataUpdate: 0,
    title: "",
    id: 0,
    columns: [
      {
        field: "id",
        headerName: "Tunniste",
        width: 100,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "title",
        headerName: "Otsikko",
        width: 100,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "google_id",
        headerName: "Google tunniste",
        width: 200,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "google_name",
        headerName: "Google näyttönimi",
        width: 220,
        sortable: true,
        filter: true,
        resizable: true,
      },

      {
        field: "apple_id",
        headerName: "Apple tunniste",
        width: 180,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "apple_name",
        headerName: "Apple näyttönimi",
        width: 220,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "freetrial",
        headerName: "Ilmainen kokeilu",
        width: 200,
        sortable: true,
        filter: true,
        resizable: true,
        valueGetter: (params) => params.data.freetrial > 0
          ? `${params.data.freetrial} ${periodUnitLabels[params.data.freetrialunit] || params.data.freetrialunit || "kk"}`
          : "-",
      },
      {
        field: "created",
        headerName: "Luotu",
        width: 160,
        sortable: true,
        filter: true,
        resizable: true,
        valueFormatter: (params) => {
          if (!params.value) return "";
          const date = new Date(params.value);
          return Number.isNaN(date.getTime())
            ? params.value
            : date.toLocaleDateString("fi-FI");
        },
      },
      {
        field: "price",
        headerName: "Hinta",
        width: 160,
        sortable: true,
        filter: true,
        resizable: true,
        valueFormatter: (params) => {
          const price = Number(params.value);
          return Number.isFinite(price) ? `${(price / 100).toFixed(2)} €` : "";
        },
      },
      {
        field: "billingperiod",
        headerName: "Laskutusajanjakso",
        width: 200,
        sortable: true,
        filter: true,
        resizable: true,
        valueGetter: (params) => {
          const unit = params.data.billingperiodunit || "month";
          return `${params.data.billingperiod} ${periodUnitLabels[unit] || unit}`;
        },
      },
    ],
  }),
  methods: {
    editPurchaseProductName(rowData) {
      this.title = rowData.title;
      this.id = rowData.id;
      this.editPurchaseProductNameModal = true;
    },
    editGameleoKeywordCancelled() {
      this.editPurchaseProductNameModal = false;
    },
    editGameleoKeywordOk() {
      this.editPurchaseProductNameModal = false;
      this.dataUpdate += 1;
    },
    googleProductSaved() {
      this.addGoogleProductModal = false;
      this.dataUpdate += 1;
    },
  },
  mounted() {},
};
</script>
